module.exports = {"full":{"All-instruments":"모든 악기","No-guitar":"기타 없음"},"details":{"Lesson-Details":"강의 세부 정보","Tablature":"기타 탭"}};